<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Add Doctor",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
         return {
            title: "Add Doctor",
            items: [
               {
                  text: "Doctors",
                  href: "/doctors",
               },
               {
                  text: "Add Doctor",
                  active: true,
               },        
            ],

            doctor: {
               name: '',
               country_code: 1,
               prefix: 1,
               mobile: '',
               email: '',
               dob: '',
               gender: '',
               qualification: '',
               current_hospital: '',
               commision:'',
               convenience_fee:'',
               symptoms_needed:2,
               no_sms_needed:2,
               unlist_doctor:2,
               no_days:2,
               hide_prescriptions:2,
               premium:2,
               address: '',
               password: "123456",
               password_confirmation: "123456",
               reg_number: '',
               reg_council: '',
               reg_date: '',
               account_number: '',
               account_holder_name: '',
               ifsc_code: '',
               upi_id: '',
               start_date: '',
               id_proof: '',
               image: '',
               specializations: '',
               sub_specializations: [],
               languages: [],
               pin_no: '',
               age_type: "1",
               age: "",
            },

            specializations: [],
            sub_specializations: [],
            languages: [],

            specialization: '',
            sub_specialization: [],
            language: '',

            certificates_inputs: [
                  {value: null, preview_image: null, image: null}
              ],
            certificates_images: [],

            countries: [],


            image: "",
            preview_image: "",

            proof_image: "",
            proof_preview_image: "",

            errors: {},
            token: '',

            today: current_date,
            
            loading: false,

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchSpecializations(1);
         this.fetchLanguages(1);
         this.fetchCountryCodes();
       
      },

      methods: {

         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         noSpaces(event) {
            let keyCode = event.keyCode;
            if(keyCode == 32) {
               event.preventDefault();
            } else {
               return;
            }
         },

         alphaSpacesOnly(event) {
            let keyCode = event.keyCode;
            if ((keyCode >= 65 && keyCode <= 90) || 
               (keyCode >= 97 && keyCode <= 122) ||               
               (keyCode == 32)) {
                 return;
            } else {
               event.preventDefault();
            }
         },

         // UPIOnly(event) {
         //    var pattern = /^[\w.-]+@[\w.-]+$/;
         //    if (pattern.test(event.keyCode)) {
         //      this.ignoredValue = event.keyCode ? event.keyCode : "";
         //      event.preventDefault();
         //    }
         // },
        
         addSubSpecialization(event) {
            let selectedOptions = [...event.target.selectedOptions]; 

            selectedOptions.forEach(option => {
               let sub_spec_id = option.value;
               let title = option.text;

               let exists = this.doctor.sub_specializations.some(sub => sub.id === sub_spec_id);

               if (!exists) {
                     this.doctor.sub_specializations.push({ id: sub_spec_id, title: title, spec_id: sub_spec_id });
               }
            });
         },

         removeSpecialization(index) {
            this.doctor.specializations.splice(index, 1);
         }, 
          removeSubSpecialization(index) {
            this.doctor.sub_specializations.splice(index, 1);
         },

         addLanguage() {
            let text = event.target.options[event.target.options.selectedIndex].label;
            let index = event.target.options.selectedIndex;
            let lan_id = event.target.options[event.target.options.selectedIndex].value;

            var exists = this.doctor.languages.some(function(language) {
               return index === language.id;
            });

            if(!exists) {
               this.doctor.languages.push({ id: index , title: text,lan_id: lan_id });
            }
            this.language = '';
         },

         removeLanguage(index) {
            this.doctor.languages.splice(index, 1);
         },           

         certificates_add() {
            this.certificates_inputs.push({ value: null });
         },

         certificates_remove(index) {
            this.certificates_inputs.splice(index, 1);
            this.certificates_images.splice(index, 1);
         }, 

         certificates_setFile(e, index) {
            this.certificates_images.push(e.target.files[0]);
            this.certificates_inputs[index].image = e.target.files[0];
            this.certificates_inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
         },

         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         setProof(e) {
            this.proof_image = e.target.files[0];
            this.proof_preview_image = URL.createObjectURL(e.target.files[0]);
         },

         fetchSpecializations(type) {
            let url = "api/admin/get-specializations?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.specializations = responseData.specializations;
               })
               .catch((err) => console.log(err));
         },

         fetchSubSpecializations(specialization_id) {
               if (!specialization_id) {
                  this.sub_specializations = [];
                  return;
               }
               let url = `api/admin/get-subspecializations?specialization_id=${specialization_id}`;         
               this.getToken();
               this.$axios
                  .get(url, { headers: { Authorization: "Bearer " + this.token } })
                  .then((res) => {
                     this.sub_specializations = res.data.data.sub_specializations || [];
                     console.log("Sub Specializations:", this.sub_specializations);
                  })
                  .catch((err) => console.log(err));
         },

         fetchLanguages(type) {
            let url = "api/admin/get-languages?type=" + type;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.languages = responseData.languages;
               })
               .catch((err) => console.log(err));
         },

         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },

         getToken() {
            if (localStorage.getItem('medicino_admin')) {
               var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
               if(medicino_admin.token) {
                  this.token = medicino_admin.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         }, 

         addDoctor() {
            this.getToken();           
            
            const config = {
               headers: {
                  "Content-type": "multipart/form-data",
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "api/admin/doctors/add";             
       
            let formData = new FormData();
            formData.append("name", this.doctor.name); 
            formData.append("mobile", this.doctor.mobile); 
            formData.append("country_code", this.doctor.country_code); 
            formData.append("email", this.doctor.email); 
            formData.append("age_type", this.doctor.age_type); 
            formData.append("age", this.doctor.age); 
            formData.append("dob", this.doctor.dob); 
            formData.append("gender", this.doctor.gender); 
            formData.append("prefix", this.doctor.prefix); 
            formData.append("qualification", this.doctor.qualification); 
            formData.append("current_hospital", this.doctor.current_hospital); 
            formData.append("address", this.doctor.address); 
            formData.append("commision", this.doctor.commision);
            formData.append("convenience_fee", this.doctor.convenience_fee);
            formData.append("password", this.doctor.password); 
            formData.append("password_confirmation", this.doctor.password_confirmation); 
            formData.append("pin_no", this.doctor.pin_no); 
            formData.append("reg_number", this.doctor.reg_number); 
            formData.append("reg_council", this.doctor.reg_council); 
            formData.append("reg_date", this.doctor.reg_date); 
            formData.append("start_date", this.doctor.start_date); 
            formData.append("no_days_booking", this.doctor.no_days); 
            formData.append("hide_prescription", this.doctor.hide_prescriptions); 
            formData.append("ask_symptoms", this.doctor.symptoms_needed); 
            formData.append("unlist", this.doctor.unlist_doctor); 
            formData.append("disable_sms", this.doctor.no_sms_needed); 
            formData.append("doctor_type", this.doctor.premium); 
            formData.append("specializations", this.doctor.specializations); 
            if(this.doctor.account_number){
               formData.append("account_number", this.doctor.account_number); 
            } else{
               formData.append("account_number", ""); 
            }
            if(this.doctor.account_holder_name){
               formData.append("account_holder_name", this.doctor.account_holder_name); 
            }else{
               formData.append("account_holder_name", ""); 
            }
            if(this.doctor.ifsc_code){
               formData.append("ifsc_code", this.doctor.ifsc_code); 
            }else{
               formData.append("ifsc_code", ""); 
            }
            if(this.doctor.ifsc_code){
               formData.append("upi_id", this.doctor.upi_id); 
            }else{
               formData.append("upi_id", ""); 
            }


            // for(var i=0; i< this.doctor.specializations.length; i++) {
            //    formData.append('specializations[' + i + ']', this.doctor.specializations[i].id);
            // }

            // for(var j=0; j< this.doctor.languages.length; j++) {
            //    formData.append('languages[' + j + ']', this.doctor.languages[j].id);
            // }    

            var sub_specializations = this.doctor.sub_specializations
                                    .filter(sub => sub.spec_id) 
                                    .map(sub => sub.spec_id); 
            

            var languages = [];
            for(var j=0; j< this.doctor.languages.length; j++) {
               languages.push(this.doctor.languages[j].lan_id);
            } 

            formData.append('sub_specializations', JSON.stringify(sub_specializations));
            formData.append('languages', JSON.stringify(languages));

            formData.append('image', this.image)  ;
            formData.append('id_proof', this.proof_image);

            for(var k = 0; k < this.certificates_images.length; k++) {
               let file = this.certificates_images[k];
               formData.append('certificates[' + k + ']', file);
            }
           
            this.loading = true;
           
            this.$axios
            .post(url, formData, config)
            .then((response) => {
                  if (response.data.status) {
                     this.$swal("", response.data.message, "success");
                  } else {
                     this.$swal("", response.data.message, "error");
                  }
                  this.clearForm();
                  this.$router.push({ name: 'doctors'});
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422);{
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                        
                        this.$swal("", error.response.data.message, "error");
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
               })
               .finally(() => (this.loading = false));
         },

         clearForm() {

            this.doctor.name = '';
            this.doctor.country_code = '';
            this.doctor.mobile = '';
            this.doctor.email = '';
            this.doctor.dob = '';
            this.doctor.gender = '';
            this.doctor.qualification = '';
            this.doctor.current_hospital = '';
            this.doctor.address = '';
            this.doctor.commision = '';
            this.doctor.convenience_fee = '';
            this.doctor.password = '';
            this.doctor.password_confirmation = '';
            this.doctor.reg_number = '';
            this.doctor.reg_council = '';
            this.doctor.reg_date = '';
            this.doctor.account_number = '';
            this.doctor.account_holder_name = '';
            this.doctor.ifsc_code = '';
            this.doctor.upi_id = '';
            this.doctor.start_date = '';
            this.doctor.id_proof = '';
            this.doctor.image = '';
            this.doctor.specializations = [];
            this.doctor.languages = [];

            this.specializations = [];
            this.sub_specializations = [];
            this.languages = [];

            this.specialization = '';
            this.sub_specialization = '';
            this.language = '';

            this.certificates_inputs = [
                  {value: null, preview_image: null, image: null}
              ];
            this.certificates_images = [];

            this.image = '';
            this.preview_image = '';

            this.proof_image = '';
            this.proof_preview_image = '';

            this.errors = {};
         }
      }
   }
</script>

<style scoped>
   .page-loader {
      display: flex;
      align-items: center;
      padding: 10px 0;
   }

   .page-loader img {
      width: 50px;
      height: 50px;
   }
</style>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                        <router-link :to="{ name: 'doctors' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  
                  <!-- <b-card header-class="bg-transparent border-light" class="border border-light"> -->
                     <form class="form-horizontal" role="form" @submit.prevent="addDoctor()">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Personal Details</h4>
                           <div class="row">

                              <div class="form-group col-md-4  has-validation">
                                 <label>Name <span class="text-danger">*</span></label>
                                 <!-- <b-input-group size="sm" prepend="Dr."> -->
                                    <b-input-group>
                                    <b-input-group-prepend>
                                 <select class="form-control" v-model="doctor.prefix" v-bind:class="{ 'is-invalid': Boolean(errors.prefix) }">
                                    <option value="1">Dr</option>
                                    <option value="2">Mr</option>
                                    <option value="3">Ms</option>
                                    <option value="4">Others</option>
                                 </select>
                                    </b-input-group-prepend>
                                    <input type="text" v-model="doctor.name" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.name) }"/>
                                    <div v-for="(val, index) in errors.name" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>   
                                 </b-input-group>
                                 
                              </div>                     
                          
                              <div class="form-group col-md-4">
                                 <label>Mobile Number <span class="text-danger">*</span></label>
                                 <b-input-group>
                                    <b-input-group-prepend>
                                       <select class="form-control" v-model="doctor.country_code">
                                          <option :value="country.id" v-for="country in countries" :key="country.id">{{country.country_code}}</option>
                                       </select>
                                    </b-input-group-prepend>
                                    <b-form-input v-model="doctor.mobile" @keypress="numbersOnly" maxlength="15" v-bind:class="{ 'is-invalid': Boolean(errors.mobile) }"></b-form-input>
                                    <div v-for="(val, index) in errors.mobile" :key="index" class="invalid-feedback">
                                       <p class="mb-0">{{ val }}</p>
                                    </div>
                                 </b-input-group>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Email </label>
                                 <input type="email" v-model="doctor.email" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.email) }"/>

                                 <div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                                <b-form-group class="col-lg-4 mb-3" v-if="doctor.age_type == 1">
                                 <label>
                                    Age <span class="text-danger">*</span>
                                    <span class="ml-2">
                                       <a href="#" @click.prevent="doctor.age_type = 2">Enter DOB Instead</a>
                                    </span>
                                 </label>

                                 <b-form-input
                                 type="number"
                                 v-model="doctor.age"
                                 min="1"
                                 class="form-control"
                                 :class="{ 'is-invalid': Boolean(errors.age) }"
                                 ></b-form-input>

                           <div v-for="(val, index) in errors.age" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-form-group>
                             
                              <div class="form-group col-md-4" v-if="doctor.age_type == 2">
                                 <label>Date of Birth <span class="text-danger">*</span><span class="ml-2">
                                    <a href="#" @click.prevent="doctor.age_type = 1">Enter Age Instead</a>
                                 </span></label>
                                 <input type="date" v-model="doctor.dob" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.dob) }" :max="today"/>

                                 <div v-for="(val, index) in errors.dob" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Gender <span class="text-danger">*</span></label>
                                 <select class="form-control" v-model="doctor.gender" v-bind:class="{ 'is-invalid': Boolean(errors.gender) }">
                                    <option value="">Select</option>
                                    <option value="1">Male</option>
                                    <option value="2">Female</option>
                                    <option value="3">Others</option>
                                 </select>

                                 <div v-for="(val, index) in errors.gender" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Qualification <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.qualification" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.qualification) }"/>

                                 <div v-for="(val, index) in errors.qualification" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label for="current_hospital">Currently Practicing Hospital </label>
                                 <input type="text" name="current_hospital" v-model="doctor.current_hospital" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.current_hospital) }"/>

                                 <div v-for="(val, index) in errors.current_hospital" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Password <span class="text-danger">*</span></label>
                                 <input type="password" v-model="doctor.password" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.password) }"/>

                                 <div v-for="(val, index) in errors.password" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Confirm Password <span class="text-danger">*</span></label>
                                 <input type="password" v-model="doctor.password_confirmation" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.password_confirmation) }"/>

                                 <div v-for="(val, index) in errors.password_confirmation" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Pin Number <span class="text-danger">*</span></label>
                                 <b-form-input v-model="doctor.pin_no" @keypress="numbersOnly" autocomplete="off" maxlength="4" v-bind:class="{ 'is-invalid': Boolean(errors.pin_no) }"></b-form-input>

                                 <div v-for="(val, index) in errors.pin_no" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Start Date <span class="text-danger">*</span></label>
                                 <input type="date" v-model="doctor.start_date" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.start_date) }" :max="today"/>

                                 <div v-for="(val, index) in errors.start_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>

                              <div class="form-group col-md-4">
                                 <label>Address <span class="text-danger">*</span></label>
                                 <textarea rows="2" v-model="doctor.address" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.address) }"></textarea>

                                 <div v-for="(val, index) in errors.address" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>                           
                             
                           </div>
                          
                        </b-card>

                        <div class="row">
                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Specializations</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                     <select class="form-control" @change="fetchSubSpecializations($event.target.value)" v-model="doctor.specializations" v-bind:class="{ 'is-invalid': Boolean(errors.specializations) }">
                                          <option value="">Select</option>
                                          <option v-for="specialization in specializations" :key="specialization.id" :value="specialization.id">
                                             {{ specialization.specialization }}
                                          </option>
                                       </select>
                                       <div v-for="(val, index) in errors.specializations" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                                 </div>

                                 
                              </b-card>
                           </div>

                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Sub Specialization</h4>

                                 <div class="row">
                                    <div class="form-group col-12">                                   
                                       <select class="form-control"  @change="addSubSpecialization($event)" v-bind:class="{ 'is-invalid': Boolean(errors.sub_specializations) }">
                                             <option value="">Select</option>
                                             <option v-for="sub in sub_specializations" :key="sub.id" :value="sub.id">
                                                {{ sub.sub_specialization }}
                                             </option>
                                       </select>

                                       <div v-for="(val, index) in errors.sub_specializations" :key="index" class="invalid-feedback">
                                             <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>
                                 </div>

                              <div class="col-12">
                                 <div class="input-tag" v-for="(sub, index) in doctor.sub_specializations" :key="index">
                                       <p>
                                          {{ sub.title }}
                                          <span @click="removeSubSpecialization(index)" class="text-danger">
                                             <i class="fas fa-times-circle"></i>
                                          </span>
                                       </p>
                                 </div>
                              </div>
                            </b-card>    
                           </div>


                           <div class="col-lg-6">                             
                              <b-card header-class="bg-transparent border-light" class="border border-light">
                                 <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Languages</h4>

                                 <div class="row">
                                    <div class="form-group col-12">
                                       <select class="form-control" @change="addLanguage()" v-model="this.language" v-bind:class="{ 'is-invalid': Boolean(errors.languages) }">
                                          <option value="">Select</option>
                                          <option :value="language.id" v-for="language in languages" :key="language.id">{{language.language}}</option>
                                       </select>

                                       <div v-for="(val, index) in errors.languages" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </div>

                                    <div class="col-12">
                                       <div class="input-tag" v-for="(language, index) in doctor.languages" :key="index">
                                             <p>{{ language.title }}<span @click="removeLanguage(index)" class="text-danger"><i class="fas fa-times-circle"></i></span></p>
                                       </div>
                                    </div>
                                 </div>

                                 
                              </b-card>
                           </div>
                        </div>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Registration Details</h4>

                           <div class="row">
                              <div class="form-group col-md-4">
                                 <label>Reg. No. <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.reg_number" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_number) }"/>

                                 <div v-for="(val, index) in errors.reg_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Council <span class="text-danger">*</span></label>
                                 <input type="text" v-model="doctor.reg_council" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_council) }"/>

                                 <div v-for="(val, index) in errors.reg_council" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-4">
                                 <label>Reg. Date <span class="text-danger">*</span></label>
                                 <input type="date" v-model="doctor.reg_date" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.reg_date) }" :max="today"/>

                                 <div v-for="(val, index) in errors.reg_date" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Bank Details</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Account No. </label>
                                 <input type="text" v-model="doctor.account_number" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.account_number) }" @keypress="numbersOnly" maxlength="20" />

                                 <div v-for="(val, index) in errors.account_number" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>Account Holder Name </label>
                                 <input type="text" v-model="doctor.account_holder_name" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.account_holder_name) }"/>

                                 <div v-for="(val, index) in errors.account_holder_name" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>IFSC Code </label>
                                 <input type="text" v-model="doctor.ifsc_code" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.ifsc_code) }" maxlength="11" />

                                 <div v-for="(val, index) in errors.ifsc_code" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>   

                              <div class="form-group col-md-6">
                                 <label>UPI ID </label>
                                 <input type="text" v-model="doctor.upi_id" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.upi_id) }" maxlength="50"/>

                                 <div v-for="(val, index) in errors.upi_id" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </div>      
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <!-- <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Image</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <label>Profile Image <span class="text-danger">*</span></label>
                                 <input type="file" class="form-control">
                              </div>
                              
                           </div> -->
                            <label>Profile Image <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                            
                           <input type="file" @change="setFile($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.image) }" />
                           <img v-if="preview_image" class="avatar-sm mt-2" :src="preview_image">

                           <div v-for="(val, index) in errors.image" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <!-- <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>

                           <div class="row">
                              <div class="form-group col-md-6">
                                 <input type="file" class="form-control">
                              </div>
                              
                           </div> -->
                           <label>ID Proof <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                            
                           <input type="file" @change="setProof($event)" accept=".png,.jpg,.jpeg" class="form-control" :class="{ 'is-invalid': Boolean(errors.id_proof) }" />
                           <img v-if="proof_preview_image" class="avatar-sm mt-2" :src="proof_preview_image">

                           <div v-for="(val, index) in errors.id_proof" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <label>Certificates <span class="text-danger">*</span> <span class="small">[Allowed formats: .jpg, .jpeg, .png]</span></label>

                           <div class="form-control" :class="{ 'is-invalid': Boolean(errors.certificates) }">

                           <b-row v-for="(input, index) in certificates_inputs" :key="index" class="mb-2">    
                              <b-col md="6" class="form-group d-flex">
                                 <div class="w-90">
                                    <b-form-file class=" form-control" accept=".jpg, .png, .jpeg"  v-model="input.value" @change="certificates_setFile($event, index)"></b-form-file>
                                 </div>

                                 <span class="ms-1 mt-2">
                                    <i class="fas fa-minus-circle text-danger" @click="certificates_remove(index)" v-show="index || ( !index && certificates_inputs.length > 1)"></i>
                                    <i class="fas fa-plus-circle text-success" @click="certificates_add()" v-show="index == certificates_inputs.length-1"></i>
                                 </span>
                              </b-col>
                              <!-- <b-col md="6">
                                 <img class="img-thumbnail" style="max-height: 80px;" v-bind:src="input.preview_image">
                              </b-col> -->
                           </b-row>
                           </div>

                           <div v-for="(val, index) in errors.certificates" :key="index" class="invalid-feedback">
                              <p class="mb-0">{{ val }}</p>
                           </div>
                        </b-card>

                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">Other Settings</h4>
                           <div class="row">
                              <div class="col-lg-6">
                                 <div class="form-group">
                                    <label>Ask questions regarding the patient's symptoms</label>
                                    <b-form-radio-group v-model="doctor.symptoms_needed" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="symptom_needed"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="symptom_needed" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <div class="form-group">
                                    <label>Disable SMS service</label>
                                    <b-form-radio-group v-model="doctor.no_sms_needed" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="sms_needed" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <div class="form-group">
                                    <label>Unlist from doctors listing</label>
                                    <b-form-radio-group v-model="doctor.unlist_doctor" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_doctor"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_doctor" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>

                                 <!-- <div class="form-group">
                                    <label>Unlist from clinics listing</label>
                                    <b-form-radio-group v-model="doctor.unlist_clinic" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div> -->

                                 <div class="form-group">
                                    <label>Hide prescription from other doctors</label>
                                    <b-form-radio-group v-model="doctor.hide_prescriptions" >
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic"  value="1">Yes</b-form-radio> 
                                       </div>
                                       <div class="form-check-inline">
                                          <b-form-radio name="unlist_clinic" value="2">No</b-form-radio>
                                       </div>
                                    </b-form-radio-group>
                                 </div>
                              </div>
                              <div class="col-lg-6">
                                 <div class="form-group">
                                    <label>Convenience Fee<span class="text-danger">*</span></label>
                                    <b-input-group prepend="Rs.">
                                       <b-form-input type="number" min="0"  v-model="doctor.convenience_fee"  v-bind:class="{ 'is-invalid': Boolean(errors.convenience_fee) }"></b-form-input>
                                       <div v-for="(val, index) in errors.convenience_fee" :key="index" class="invalid-feedback">
                                          <p class="mb-0">{{ val }}</p>
                                       </div>
                                    </b-input-group>
                                 </div>
                                 <div class="form-group">
                                 <label class="control-label">Platform Fee<span class="text-danger">*</span></label>
                                 <b-input-group prepend="Rs.">
                                 <b-form-input type="number" min="0"  v-model="doctor.commision"  v-bind:class="{ 'is-invalid': Boolean(errors.commision) }"></b-form-input>
                                 
                                 <div v-for="(val, index) in errors.commision" :key="index" class="invalid-feedback">
                                    <p class="mb-0">{{ val }}</p>
                                 </div>
                              </b-input-group>

                              </div>
                                 <div class="form-group">
                                    <label>No. of days to show for booking</label>
                                    <b-input-group append="days">
                                       <input type="text" class="form-control" v-model="doctor.no_days"  />
                                    </b-input-group>
                                 </div>
                                 <div class="form-group">
                                    <b-form-checkbox
                                       v-model="doctor.premium"
                                       name="premium"
                                       value="1"
                                       unchecked-value="2"
                                    >
                                       <span class="ms-2">Premium Doctor</span>
                                    </b-form-checkbox>
                                 </div>
                              </div>
                           </div>

                        </b-card>
                        <div class="row mt-3">
                           <div class="12">
                              <div v-if="loading" class="page-loader">
                                 <img src="@/assets/images/preloaderspin.gif"/>
                              </div>
                              <div v-else>
                                 <button class="btn btn-primary me-2" type="submit">Save</button>
                                 <router-link :to="{ name: 'doctors' }" class="btn btn-light">Cancel</router-link>
                              </div>
                           </div>
                        </div>
                     </form>
                  <!-- </b-card> -->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
